export const formatPhoneNumber = (s: string) => {
  const s2 = (s || "").replace(/\D/g, "");
  const m1 = s2.slice(0, 3);
  const m2 = s2.slice(3, 6);
  const m3 = s2.slice(6, 10);
  return `${m1 || ""}${m2 ? `-${m2}${m3 ? `-${m3}` : ""}` : ""}`;
};

export const titleCase = (str: string): string =>
  str
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map(word => word.replace(word[0], word[0].toUpperCase()))
    .join(" ");

export default titleCase;



// WEBPACK FOOTER //
// ./src/utils/format.ts